module.exports = __webpack_public_path__ + "static/media/bannerImg.ee1f1643.png";